import { getDeviceId } from '../utils'
import { auth_api_uri } from '../config/Auth0'
import logout from './logout'

export default async function authenticate() {
  const url = new URL(window.location.href)
  const appState = localStorage.getItem('appState')

  if (Boolean(localStorage.getItem('user'))) {
    if (appState) {
      window.location.href = appState
    } else {
      window.location.href = '/'
    }
  }

  try {
    const exchangeToken = url.searchParams.get('exchange_token')
    const deviceId = await getDeviceId()
    if (exchangeToken) {
      const response = await fetch(`${auth_api_uri}/api/auth/exchange`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Client': 'web'
        },
        credentials: 'include',
        body: JSON.stringify({
          token: exchangeToken,
          device_id: deviceId
        })
      })

      if (!response.ok) throw new Error('server_error')

      const { user, expires } = await response.json()

      localStorage.setItem('user', JSON.stringify(user))
      localStorage.setItem('expiration', String(expires))

      if (appState) {
        window.location.href = appState
      } else {
        window.location.href = '/'
      }
    }
  } catch (error) {
    console.error('Error handling deep link:', error)
    logout()
    window.location.href = '/?auth_error=true'
  }
}
